import { Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-primeng-toggle-switch',
  templateUrl: './primeng-toggle-switch.component.html',
  styleUrls: ['./primeng-toggle-switch.component.scss'],
  standalone: false,
})
export class PrimengToggleSwitchComponent {
  value = model<boolean>(false);
  disabled = input<boolean>(false);
  readonly = input<boolean>(false);
  label = input<string>('');
  labelPosition = input<'left' | 'right'>('right');
  trueValue = input<any>(true);
  falseValue = input<any>(false);
  id = input<string>('');

  onChange = output<any>();

  handleChange(event: any) {
    this.onChange.emit(event);
  }
}
